"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Svg24MoneyDefault = function Svg24MoneyDefault(_ref) {
  var fill = _ref.fill,
      useDefaultColors = _ref.useDefaultColors,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "useDefaultColors", "title"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: useDefaultColors ? 'none' : fill,
    "aria-hidden": title === null || typeof title !== 'string' || title.length === 0
  }, props), _react.default.createElement("title", null, title), _react.default.createElement("path", {
    d: "M11.894 18.15c1.117 0 1.938-.292 2.476-.756.535-.46.814-1.108.814-1.874 0-.451-.118-.804-.318-1.092-.202-.292-.498-.531-.87-.739-.631-.351-1.439-.59-2.307-.846-.172-.05-.346-.102-.522-.155-1.043-.316-2.128-.69-2.95-1.35-.838-.673-1.393-1.633-1.393-3.078 0-2.125 1.585-3.95 4.18-4.337l-.002-.92a1 1 0 1 1 2-.005l.002.926a6.31 6.31 0 0 1 3.209 1.514c.373.336.34.91-.016 1.264-.426.426-1.131.36-1.61-.004a4.27 4.27 0 0 0-2.583-.848c-2.017 0-3.07 1.18-3.07 2.41 0 .451.118.804.318 1.092.202.292.498.531.87.739.631.351 1.439.59 2.307.846.172.05.346.102.522.155 1.043.316 2.128.69 2.95 1.35.838.673 1.393 1.633 1.393 3.078 0 1.208-.404 2.279-1.178 3.088-.735.768-1.79 1.286-3.112 1.47l-.002.924a1 1 0 1 1-2-.004l.002-.892a6.92 6.92 0 0 1-3.315-1.265c-.189-.137-.45-.39-.688-.638a.904.904 0 0 1-.011-1.231c.393-.436 1.093-.383 1.54-.002.919.784 2.136 1.18 3.364 1.18z",
    fill: useDefaultColors ? '#191919' : fill
  }));
};

Svg24MoneyDefault.propTypes = {
  title: _propTypes.default.string,
  fill: _propTypes.default.string,
  useDefaultColors: _propTypes.default.bool
};
var _default = Svg24MoneyDefault;
exports.default = _default;